import { DatePicker } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import CustomButton from "components/form";
import React, { useState } from "react";
import {
  adddOrUpdatePreTextApi,
  adddOrUpdateQuestionApi,
} from "services/question";
import { toastMessage } from "utils/toastMessage";

const Question6 = ({
  preTextContent,
  setPreTextContent,
  errors,
  validation,
}) => {
  // handle all statue

  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save");

  const handleStartDate = (date) => {
    setPreTextContent((prev) => ({
      ...prev,
      startDate: new Date(date),
    }));
  };

  const handleEndDate = (date) => {
    setPreTextContent((prev) => ({
      ...prev,
      endDate: new Date(date),
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreTextContent((prev) => ({
        ...prev,
        image: file,
      }));
    }
  };

  console.log(preTextContent, "preTextContent");

  const adddOrUpdatePreTextHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = {
          popupStartDate: preTextContent?.startDate,
          popupEndDate: preTextContent?.endDate,
          image: preTextContent?.image,
        };
        const res = await adddOrUpdatePreTextApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(
            res?.data?.message,
            "success",
            "adddOrUpdatePreTextHandler"
          );
        } else {
          toastMessage(
            res?.data?.message,
            "error",
            "adddOrUpdatePreTextHandler"
          );
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };

  return (
    <>
      <div className="form_field page_title">
        <div>
          <DatePicker
            label="Start Date"
            className="form-control "
            name="startDate"
            selected={preTextContent?.startDate}
            placeholder="Start Date"
            onChange={(date) => handleStartDate(date)}
            maxDate={preTextContent?.endDate}
            error={!preTextContent?.startDate && errors?.startDate}
          />
        </div>
        <div>
          <DatePicker
            label="End Date"
            name="endDate"
            className="form-control"
            placeholder="End Date"
            selected={preTextContent?.endDate}
            onChange={(date) => handleEndDate(date)}
            // minDate={searchStartDate}
            error={!preTextContent?.endDate && errors?.endDate}
          />
        </div>
      </div>
      <div className="image_preview">
        <label className="label">Upload Image</label>
        <label className="file_uploader" htmlFor="upload_image">
          <input
            type="file"
            accept="image/*"
            id="upload_image"
            onChange={handleFileChange}
          />
          {preTextContent?.image && (
            <img
              src={
                typeof preTextContent.image === "string"
                  ? preTextContent.image
                  : URL.createObjectURL(preTextContent.image)
              }
              alt="Preview"
            />
          )}
        </label>
        {!preTextContent?.image && <span>{errors?.image}</span>}
      </div>

      <div className="button_wrap ">
        <CustomButton ref={buttonLoaders} onClick={adddOrUpdatePreTextHandler}>
          Save
        </CustomButton>
      </div>
    </>
  );
};

export default Question6;
